'use es6';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import UIButton from 'UIComponents/button/UIButton';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PracticalExerciseWrapper from './PracticalExerciseWrapper';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_18N_KEY = 'learningCenter.practicalExercise';
const InProgressPracticalExercise = ({
  exercise,
  advanceToNextContent,
  contentId,
  lessonId,
  trackId,
  exerciseLocation
}) => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "in-progress-practical-exercise",
    children: /*#__PURE__*/_jsx(PracticalExerciseWrapper, {
      buttons: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
          className: "m-right-3",
          contentId: contentId,
          "data-test-id": "practical-exercise-retry-button",
          lessonId: lessonId,
          trackId: trackId,
          use: "tertiary-light"
        }), /*#__PURE__*/_jsx(Link, {
          to: exerciseLocation,
          children: /*#__PURE__*/_jsx(UIButton, {
            external: true,
            use: "secondary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.practicalExercise.external.started.exerciseLink"
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          className: "m-left-3",
          onClick: advanceToNextContent,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${BASE_18N_KEY}.next`
          })
        })]
      }),
      illustrationName: "note-widget",
      children: /*#__PURE__*/_jsxs("div", {
        className: "practical-exercise-instructions",
        children: [/*#__PURE__*/_jsx("h4", {
          children: exercise.name
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.practicalExercise.instructions.inProgress.top.manual"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.instructions.inProgress.top.certified"
          })
        })]
      })
    })
  });
};
InProgressPracticalExercise.propTypes = {
  advanceToNextContent: PropTypes.func.isRequired,
  contentId: PropTypes.string.isRequired,
  exercise: PropTypes.object.isRequired,
  exerciseLocation: PropTypes.string,
  lessonId: PropTypes.string.isRequired,
  trackId: PropTypes.string
};
export default InProgressPracticalExercise;